import * as THREE from 'three'
import Experience from '../Experience.js'

export default class Environment
{
    constructor()
    {
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.resources = this.experience.resources
        this.debug = this.experience.debug
        
        // Debug
        if(this.debug.active)
        {
            this.debugFolder = this.debug.ui.addFolder('environment')
        }

        this.scene.background = null

        this.setBlenderLights()
        this.setEnvironmentMap()
    }

    setBlenderLights()
    {
        this.lights = []
        const model = this.resources.items.braceletModel.scene

        model.traverse((child) =>
        {
            if(child.name === 'Area' || child.name === 'Area001' || child.name === 'Area002')
            {
                const light = new THREE.SpotLight('#ffffff', 10, 20, Math.PI / 3, 0.5, 1)
                child.getWorldPosition(light.position)

                const dir = new THREE.Vector3(0, 0, -1)
                dir.applyQuaternion(child.quaternion)
                light.target.position.copy(light.position).add(dir)
                this.scene.add(light.target)

                light.castShadow = false

                this.scene.add(light)
                this.lights.push({ light, name: child.name })

                child.visible = false
            }
        })

        this.ambientLight = new THREE.AmbientLight('#ffffff', 1)
        this.scene.add(this.ambientLight)

        // Debug
        if(this.debug.active)
        {
            this.lights.forEach(({ light, name }) =>
            {
                const folder = this.debugFolder.addFolder(name)
                folder.add(light, 'intensity').min(0).max(50).step(0.1)
                folder.add(light.position, 'x').name('posX').min(-10).max(10).step(0.01)
                folder.add(light.position, 'y').name('posY').min(-10).max(10).step(0.01)
                folder.add(light.position, 'z').name('posZ').min(-10).max(10).step(0.01)
            })

            this.debugFolder.add(this.ambientLight, 'intensity').name('ambientIntensity').min(0).max(5).step(0.01)
        }
    }

    setEnvironmentMap(texture = this.resources.items.environmentMapTexture)
    {
        if(!texture)
            return

        this.environmentMap = {}
        this.environmentMap.intensity = 0.4
        this.environmentMap.texture = texture
        this.environmentMap.texture.colorSpace = THREE.SRGBColorSpace

        this.scene.environment = this.environmentMap.texture
        this.scene.background = null

        this.environmentMap.updateMaterials = () =>
        {
            this.scene.traverse((child) =>
            {
                if(child instanceof THREE.Mesh && child.material instanceof THREE.MeshStandardMaterial)
                {
                    child.material.envMap = this.environmentMap.texture
                    child.material.envMapIntensity = this.environmentMap.intensity
                    child.material.needsUpdate = true
                }
            })
        }
        this.environmentMap.updateMaterials()

        // Debug
        if(this.debug.active)
        {
            this.debugFolder
                .add(this.environmentMap, 'intensity')
                .name('envMapIntensity')
                .min(0)
                .max(4)
                .step(0.001)
                .onChange(this.environmentMap.updateMaterials)
        }
    }
}